import React from "react";
import "../css/Loader.css";

const Loader = () => {
  return (
    <div class="loader-container">
      <div class="loader"></div>
      <div class="loader-text">Getting Products...</div>
    </div>
  );
};

export default Loader;
